import { format } from 'date-fns';
import React from 'react';
import { $colors } from 'src/theme';
import { HistoryPublicModelData } from 'src/types/public/public-data-model.types';
import { TrackingColiInfoTemplateIcon } from '../../TrackingColiInfoTemplateIcon';
import { PTrackingColiHistoryTemplatePops, TrackingColiHistoryTemplate } from '../TrackingColiHistoryTemplate';
import { getHistoryColiStatusByHistoryItem } from './getHistoryColiStatusByHistoryItem';

type Props = {
  history: HistoryPublicModelData;
  topTail?: boolean;
  bottomTail?: boolean;
};

export const TrackingColiInfoHistoryViewerItem: React.FC<Props> = ({ topTail, bottomTail, history }) => {
  const { subStatus, status, icon } = getHistoryColiStatusByHistoryItem(history);
  const dateFromString = new Date(history.createdAt);
  const date = format(dateFromString, 'dd/MM/yyyy');
  const hour = format(dateFromString, " k'h'mm");
  const props: PTrackingColiHistoryTemplatePops = {
    leftTitle: {
      label: date,
    },
    leftSubTitle: {
      label: hour,
    },
    subStatus: subStatus,
    icon: <TrackingColiInfoTemplateIcon Icon={icon} theme="round" />,
    status: {
      label: status,
    },
  };
  return (
    <TrackingColiHistoryTemplate
      {...props}
      topTail={topTail}
      bottomTail={bottomTail}
      mainRightTextStyle={history.status === 'CANCELLED' ? { color: $colors.error } : null}
      style={history.status === 'CANCELLED' ? { opacity: 0.6 } : undefined}
    />
  );
};
